<template>
  <div class="home" @click="hideSelectCurrency">
    <div class="header">
      <div class="headerButton" @click="goCompetitions">
        <img src="../assets/icons/competitions.svg" />
        <p>{{ $t("competitions") }}</p>
      </div>
      <div></div>
      <div style="display: flex; gap: 5px">
        <div class="headerButton" @click="goSettings">
          <img src="../assets/icons/settings.svg" />
          <p>{{ $t("settings") }}</p>
        </div>
        <div class="headerButton" @click="goNotifications">
          <img src="../assets/icons/bell.svg" />
        </div>
      </div>
    </div>
    <div class="balance">
      <div class="headBalance">
        <p style="display: flex; gap: 5px; position: relative">
          {{ $t("your-balance") }}
          <span
            style="
              color: #007aff;
              font-weight: 600;
              cursor: pointer;
              display: flex;
              align-items: center;
              gap: 7px;
            "
            @click="openCurrencies"
            >{{ currency.name }}
            <svg
              width="12"
              height="7"
              viewBox="0 0 12 7"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.5 1.5L6 6L10.5 1.5"
                stroke="#007AFF"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
          <Transition name="fade">
            <span class="selectCurrencies" v-if="isSelectCurrency">
              <p @click="selectCurrency('RUB')">RUB</p>
              <p @click="selectCurrency('UAH')">UAH</p>
              <p @click="selectCurrency('USD')">USD</p>
              <p @click="selectCurrency('KZT')">KZT</p>
            </span>
          </Transition>
        </p>
      </div>
      <!-- Loader для баланса -->
      <div class="balanceBlock" v-if="isBalanceLoading">
        <BalanceSkeleton size="lg" />
        <span>{{ currency.symbol }}</span>
      </div>
      <!-- Сам баланс -->
      <div class="balanceBlock" v-else>
        <p>
          {{ balance.toLocaleString(dateLocale) }}.<span>{{ balanceCents }}</span>
        </p>
        <span>{{ currency.symbol }}</span>
      </div>
    </div>
    <div class="mainButtons">
      <div class="mainButton" @click="$router.push('/finance/deposit')">
        <svg
          width="36"
          height="36"
          viewBox="0 0 36 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect x="8.25" y="9" width="20" height="21" fill="white" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M1.875 18C1.875 9.09441 9.09441 1.875 18 1.875C26.9056 1.875 34.125 9.09441 34.125 18C34.125 26.9056 26.9056 34.125 18 34.125C9.09441 34.125 1.875 26.9056 1.875 18ZM18.75 12C18.75 11.5858 18.4142 11.25 18 11.25C17.5858 11.25 17.25 11.5858 17.25 12V22.1893L14.0303 18.9697C13.7374 18.6768 13.2626 18.6768 12.9697 18.9697C12.6768 19.2626 12.6768 19.7374 12.9697 20.0303L17.4697 24.5303C17.7626 24.8232 18.2374 24.8232 18.5303 24.5303L23.0303 20.0303C23.3232 19.7374 23.3232 19.2626 23.0303 18.9697C22.7374 18.6768 22.2626 18.6768 21.9697 18.9697L18.75 22.1893V12Z"
            fill="#007AFF"
          />
        </svg>

        <p>{{ $t("deposit") }}</p>
      </div>
      <div class="mainButton" @click="$router.push('/finance/withdraw')">
        <svg
          width="37"
          height="36"
          viewBox="0 0 37 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect x="11.25" y="10" width="14" height="16" fill="white" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M34.625 18C34.625 26.9056 27.4056 34.125 18.5 34.125C9.59441 34.125 2.375 26.9056 2.375 18C2.375 9.09441 9.59441 1.875 18.5 1.875C27.4056 1.875 34.625 9.09441 34.625 18ZM17.75 24C17.75 24.4142 18.0858 24.75 18.5 24.75C18.9142 24.75 19.25 24.4142 19.25 24L19.25 13.8107L22.4697 17.0303C22.7626 17.3232 23.2374 17.3232 23.5303 17.0303C23.8232 16.7374 23.8232 16.2626 23.5303 15.9697L19.0303 11.4697C18.8897 11.329 18.6989 11.25 18.5 11.25C18.3011 11.25 18.1103 11.329 17.9697 11.4697L13.4697 15.9697C13.1768 16.2626 13.1768 16.7374 13.4697 17.0303C13.7626 17.3232 14.2374 17.3232 14.5303 17.0303L17.75 13.8107L17.75 24Z"
            fill="#007AFF"
          />
        </svg>

        <p>{{ $t("withdraw") }}</p>
      </div>
      <div class="mainButton" @click="goTrading(actives[0])">
        <svg
          width="36"
          height="36"
          viewBox="0 0 36 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect x="10.25" y="8" width="16" height="21" fill="white" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M1.875 18C1.875 9.09441 9.09441 1.875 18 1.875C26.9056 1.875 34.125 9.09441 34.125 18C34.125 26.9056 26.9056 34.125 18 34.125C9.09441 34.125 1.875 26.9056 1.875 18ZM18.7498 9.75C18.7498 9.33579 18.414 9 17.9998 9C17.5856 9 17.2498 9.33579 17.2498 9.75V11.25H16.1149C14.2564 11.25 12.7498 12.7566 12.7498 14.6151C12.7498 16.0636 13.6767 17.3495 15.0508 17.8076L17.2498 18.5406V23.25H16.4998C15.2572 23.25 14.2498 22.2426 14.2498 21C14.2498 20.5858 13.914 20.25 13.4998 20.25C13.0856 20.25 12.7498 20.5858 12.7498 21C12.7498 23.0711 14.4287 24.75 16.4998 24.75H17.2498V26.25C17.2498 26.6642 17.5856 27 17.9998 27C18.414 27 18.7498 26.6642 18.7498 26.25V24.75H19.8847C21.7432 24.75 23.2498 23.2434 23.2498 21.3849C23.2498 19.9364 22.323 18.6505 20.9488 18.1924L18.7498 17.4594V12.75H19.4998C20.7425 12.75 21.7498 13.7574 21.7498 15C21.7498 15.4142 22.0856 15.75 22.4998 15.75C22.914 15.75 23.2498 15.4142 23.2498 15C23.2498 12.9289 21.5709 11.25 19.4998 11.25H18.7498V9.75ZM16.1149 12.75H17.2498V16.9594L15.5251 16.3845C14.7635 16.1307 14.2498 15.4179 14.2498 14.6151C14.2498 13.585 15.0849 12.75 16.1149 12.75ZM18.7498 23.25V19.0406L20.4745 19.6155C21.2361 19.8693 21.7498 20.5821 21.7498 21.3849C21.7498 22.415 20.9148 23.25 19.8847 23.25H18.7498Z"
            fill="#007AFF"
          />
        </svg>

        <p>{{ $t("trade") }}</p>
      </div>
      <div class="mainButton" @click="openSupport">
        <svg
          width="37"
          height="36"
          viewBox="0 0 37 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18.25 1.875C9.34441 1.875 2.125 9.09441 2.125 18C2.125 26.9056 9.34441 34.125 18.25 34.125C27.1556 34.125 34.375 26.9056 34.375 18C34.375 9.09441 27.1556 1.875 18.25 1.875Z"
            fill="#007AFF"
          />
          <path
            d="M25.5417 21.75V17.7917C25.5417 13.7646 22.2771 10.5 18.25 10.5V10.5C14.2229 10.5 10.9583 13.7646 10.9583 17.7917V21.75M25.5417 23.3125V20.9375C25.5417 20.7634 25.5417 20.6763 25.5363 20.6029C25.4633 19.6143 24.6773 18.8283 23.6888 18.7554C23.6153 18.75 23.5283 18.75 23.3542 18.75V18.75C23.1801 18.75 23.093 18.75 23.0195 18.7554C22.031 18.8283 21.245 19.6143 21.1721 20.6029C21.1667 20.6763 21.1667 20.7634 21.1667 20.9375V23.3125C21.1667 23.4866 21.1667 23.5737 21.1721 23.6471C21.245 24.6357 22.031 25.4217 23.0195 25.4946C23.093 25.5 23.1801 25.5 23.3542 25.5V25.5C23.5283 25.5 23.6153 25.5 23.6888 25.4946C24.6773 25.4217 25.4633 24.6357 25.5363 23.6471C25.5417 23.5737 25.5417 23.4866 25.5417 23.3125ZM13.1458 25.5V25.5C13.32 25.5 13.407 25.5 13.4805 25.4946C14.469 25.4217 15.255 24.6357 15.3279 23.6471C15.3333 23.5737 15.3333 23.4866 15.3333 23.3125V20.9375C15.3333 20.7634 15.3333 20.6763 15.3279 20.6029C15.255 19.6143 14.469 18.8283 13.4805 18.7554C13.407 18.75 13.32 18.75 13.1458 18.75V18.75C12.9717 18.75 12.8847 18.75 12.8112 18.7554C11.8227 18.8283 11.0367 19.6143 10.9638 20.6029C10.9583 20.6763 10.9583 20.7634 10.9583 20.9375V23.3125C10.9583 23.4866 10.9583 23.5737 10.9638 23.6471C11.0367 24.6357 11.8227 25.4217 12.8112 25.4946C12.8847 25.5 12.9717 25.5 13.1458 25.5Z"
            stroke="white"
            stroke-width="1.3"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <p>{{ $t("support") }}</p>
      </div>
    </div>
    <Transition name="fade">
      <div class="bannerBlock" v-if="isBannerShow">
        <img
          src="../assets/icons/closeBanner.svg"
          class="closeBanner"
          @click="isBannerShow = false"
        />
      </div>
    </Transition>
    <p class="activesText">{{ $t("actives") }}</p>
    <div class="activesBlock">
      <ActivesSkeleton v-if="isActivesLoading" :count="5" />
      <!-- Реальные активы -->
      <template v-else>
        <div
          class="activeBlock"
          v-for="(item, index) in actives"
          :key="index"
          @click="goActive(item)"
        >
          <img :src="item.img" class="active-icon" />
          <div class="infoText">
            <div class="activeLine bottomActive">
              <p>{{ item.name }}</p>
              <p style="display: flex; gap: 10px">
                <template v-if="isTradeShare">
                  {{ (item.multi_fiat_value?.rub_value || item.usd_value || 0).toLocaleString("ru-RU", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }} ₽
                </template>
                <template v-else>
                  ${{ item.usd_value.toLocaleString("en-US") }}
                </template>
                <span :class="item.changePercent < 0 ? 'percentRed' : 'percentGreen'"
                  >{{ item.changePercent }}%</span
                >
              </p>
            </div>
            <div class="activeLine headActive bottomActive">
              <p>{{ item.amount }} {{ item.symbol }}</p>
              <p style="text-align: right">{{ item.fiat_value }} {{ currency.symbol }}</p>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { UserManager } from "@/utils/userManager";
import { getDateLocale } from "@/utils/apiErrors";
import { applyBalanceResponse } from "@/utils/balanceHelpers";
import BalanceSkeleton from "@/components/BalanceSkeleton.vue";
import ActivesSkeleton from "@/components/ActivesSkeleton.vue";

export default {
  name: "MainPage",
  components: {
    BalanceSkeleton,
    ActivesSkeleton,
  },
  data() {
    return {
      currency: {
        name: this.$store.getters.getCurrency,
        symbol: "₽",
      },
      user: null,
      botId: null,
      balance: 0,
      balanceCurrencies: null,
      balanceCents: "00",
      isBannerShow: false,
      actives: [],
      allActives: [], // Все доступные активы из /actives/list
      userActives: [], // Активы пользователя из /actives/user
      isSelectCurrency: false,
      isBalanceLoading: true, // Добавлено
      isActivesLoading: true, // Добавлено
      isTradeShare: false, // Тип бота: TRADE SHARE или TRADE
    };
  },
  computed: {
    dateLocale() {
      return getDateLocale(this.$store.getters.getLanguage);
    },
  },
  watch: {
    actives: {
      handler(newVal, oldVal) {
        console.log("[MainPage] watch actives - Изменение actives:", {
          old: oldVal?.length || 0,
          new: newVal?.length || 0,
          newVal: newVal
        });
      },
      deep: true,
      immediate: true
    },
    isActivesLoading(newVal) {
      console.log("[MainPage] watch isActivesLoading - Изменение:", newVal);
    }
  },
  methods: {
    goSettings() {
      this.$router.push("/settings");
    },
    goNotifications() {
      this.$router.push("/notifications");
    },
    goCompetitions() {
      this.$router.push("/competitions");
    },
    goActive(currency) {
      console.log(currency, this.actives);
      this.$router.push("/active/" + currency.symbol.toLowerCase());
    },
    goTrading(currency) {
      this.$store.commit("setTradeSymbol", currency);
      this.$router.push("/trading");
    },
    openCurrencies() {
      this.isSelectCurrency = true;
    },
    hideSelectCurrency(event) {
      if (
        !event.target.closest(".selectCurrencies") &&
        !event.target.closest("span") &&
        this.isSelectCurrency
      )
        this.isSelectCurrency = false;
    },
    openSupport() {
      if (!this.user || !this.botId) {
        console.error("Нет данных пользователя для запроса ТП");
        return;
      }

      fetch(`${window.location.origin}/tech/tp?bot_id=${this.botId}&user_id=${this.user.id}`)
        .then((res) => res.json())
        .then((data) => {
          if (data.success && data.tp) {
            const supportLink = `https://t.me/${data.tp}`;
            window.location.href = supportLink;
          } else {
            window.location.href = "https://t.me/";
          }
        })
        .catch((err) => {
          console.error("Ошибка при получении ссылки на ТП:", err);
          window.location.href = "https://t.me/";
        });
    },
    fetchActives() {
      console.log("[fetchActives] Начало загрузки активов");
      console.log("[fetchActives] Текущие данные:", { user: this.user, botId: this.botId, actives: this.actives });
      
      // Убеждаемся, что bot_id есть
      if (!this.botId) {
        console.log("[fetchActives] bot_id отсутствует, получаем из UserManager");
        const userContext = UserManager.getFullUserContext();
        this.botId = userContext.botId;
        this.$store.commit("setBotId", this.botId);
        console.log("[fetchActives] bot_id установлен:", this.botId);
      }
      
      if (!this.user || !this.botId) {
        console.error("[fetchActives] ОШИБКА: Нет данных пользователя для запроса активов", { user: this.user, botId: this.botId });
        this.isActivesLoading = false;
        return;
      }

      console.log("[fetchActives] Запрос активов пользователя:", { botId: this.botId, userId: this.user.id });
      this.isActivesLoading = true; // Добавлено

      // Загружаем данные параллельно
      Promise.all([
        fetch(`${window.location.origin}/actives/user/${this.botId}/${this.user.id}`).then(res => res.json()),
        fetch(`${window.location.origin}/actives/list?bot_id=${this.botId}`).then(res => res.json())
      ])
        .then(([userData, listData]) => {
          console.log("[fetchActives] Данные активов пользователя получены:", userData);
          console.log("[fetchActives] Данные /actives/list получены:", listData);
          
          this.userActives = userData.actives || [];
          this.allActives = listData.actives || [];
          
          console.log("[fetchActives] Количество активов пользователя:", this.userActives.length);
          console.log("[fetchActives] Количество всех активов:", this.allActives.length);
          
          // Сохраняем multi_fiat_value в store
          this.$store.commit("setMultiFiatValue", this.allActives);
          
          // Объединяем данные: используем все активы из списка и дополняем данными пользователя
          const userActivesMap = new Map();
          this.userActives.forEach(active => {
            userActivesMap.set(active.symbol, active);
          });
          
          // Создаем объединенный массив
          this.actives = this.allActives.map(active => {
            const userActive = userActivesMap.get(active.symbol);
            if (userActive) {
              // Если есть данные пользователя, используем их
              return {
                ...active,
                amount: userActive.amount || 0,
                fiat_value: userActive.fiat_value || 0,
              };
            } else {
              // Если нет данных пользователя, добавляем нулевые значения
              return {
                ...active,
                amount: 0,
                fiat_value: 0,
              };
            }
          });
          
          console.log("[fetchActives] Объединенный массив actives создан:", this.actives.length, "элементов");
          console.log("[fetchActives] Первые 3 элемента actives:", this.actives.slice(0, 3));
          
          this.$store.commit("setActives", this.actives);
          console.log("[fetchActives] actives сохранены в store");
          
          this.isActivesLoading = false;
          console.log("[fetchActives] isActivesLoading установлен в false");
          console.log("[fetchActives] Финальное состояние this.actives:", this.actives);
        })
        .catch((err) => {
          console.error("[fetchActives] Ошибка при загрузке активов:", err);
          this.isActivesLoading = false;
        });
    },
    getBalance({ silent = false } = {}) {
      if (!this.user || !this.botId) {
        console.error("Нет данных пользователя для запроса баланса");
        if (!silent) {
          this.isBalanceLoading = false;
        }
        return;
      }

      if (!silent) {
        this.isBalanceLoading = true;
      }

      axios
        .get(`${window.location.origin}/user/balance/${this.botId}/${this.user.id}`)
        .then((res) => {
          if (applyBalanceResponse(res.data, this)) {
            this.$store.commit("setBalanceData", res.data);
          }
          this.isBalanceLoading = false;
        })
        .catch((err) => {
          console.log("БАЛАНС ОШИБКА", err);
          if (!this.balanceCurrencies) {
            this.balance = 0;
            this.balanceCents = "00";
          }
          this.isBalanceLoading = false;
        });
    },
    changeCurrency() {},
    updateCurrencySymbol(currency) {
      const symbols = {
        RUB: "₽",
        USD: "$",
        UAH: "₴",
        KZT: "₸",
      };
      this.currency.symbol = symbols[currency];
    },
    async selectCurrency(cur) {
      try {
        const response = await axios.post(
          `${window.location.origin}/user/set_currency/${this.botId}/${this.user.id}?currency=${cur}`
        );
        console.log(response);
        this.currency.name = cur;
        const [wholePart, fractionalPart] = this.balanceCurrencies[cur].toString().split(".");
        this.balance = parseInt(wholePart) || 0;
        this.balanceCents = (fractionalPart || "00").padEnd(2, "0").substring(0, 2);
        this.updateCurrencySymbol(cur);
        this.isSelectCurrency = false;
        this.$store.commit("setCurrency", cur);
      } catch (err) {
        console.log(err);
      }
    },
    async checkBotType() {
      if (!this.botId) {
        return;
      }
      try {
        const response = await axios.get(`${window.location.origin}/tech/bot_type/${this.botId}`);
        if (response.data && response.data.success) {
          this.isTradeShare = response.data.is_trade_share || false;
          console.log("Тип бота:", this.isTradeShare ? "TRADE SHARE" : "TRADE");
        }
      } catch (err) {
        console.error("Ошибка при проверке типа бота:", err);
        this.isTradeShare = false;
      }
    },
  },
  mounted() {
    console.log("[MainPage] mounted - начало инициализации");
    console.log("[MainPage] mounted - текущее состояние actives:", this.actives);
    console.log("[MainPage] mounted - isActivesLoading:", this.isActivesLoading);
    
    const userContext = UserManager.getFullUserContext();
    this.user = userContext.user;
    this.botId = userContext.botId;

    console.log("[MainPage] mounted - Данные пользователя:", this.user);
    console.log("[MainPage] mounted - Bot ID:", this.botId);

    this.$store.commit("setTgUserData", this.user);
    this.$store.commit("setBotId", this.botId);
    console.log("[MainPage] mounted - Данные сохранены в store");
    console.log(this.$store.getters.getCurrency);
    switch (this.$store.getters.getCurrency) {
      case "RUB":
        this.currency.symbol = "₽";
        break;
      case "USD":
        this.currency.symbol = "$";
        break;
      case "UAH":
        this.currency.symbol = "₴";
        break;
      case "KZT":
        this.currency.symbol = "₸";
        break;
    }
    if (this.user && this.botId) {
      const cachedBalance = this.$store.getters.getBalanceData;
      if (cachedBalance && applyBalanceResponse(cachedBalance, this)) {
        this.isBalanceLoading = false;
        this.getBalance({ silent: true });
      } else {
        this.getBalance();
      }

      this.checkBotType();
      this.fetchActives();
    } else {
      console.error("[MainPage] mounted - ОШИБКА: Не удалось инициализировать данные пользователя", { user: this.user, botId: this.botId });
    }
    
    console.log("[MainPage] mounted - завершение инициализации");
  },
};
</script>

<style scoped>
.home {
  padding: 5% 3% 5% 3%;
  display: flex;
  flex-direction: column;
  gap: 3vh;
  background-color: var(--background-color);
  height: 100vh;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.headerButton {
  display: flex;
  gap: 5px;
  color: #007aff;
  font-size: 14px;
  background-color: var(--button-background);
  border-radius: 60px;
  padding: 6px 12px 6px 12px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.headBalance {
  font-size: 17px;
  font-weight: 500;
  color: var(--text-color2);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
}
.selectCurrencies {
  position: absolute;
  top: 110%;
  right: 0;
  background-color: color-mix(in srgb, var(--second-color) 70%, transparent);
  border-radius: 15px;
  width: 25vw;
  z-index: 5;
  padding: 5px 10px;
  display: flex;
  flex-direction: column;
  gap: 5px;
  border: 1px solid rgba(255, 255, 255, 0.287);
  backdrop-filter: blur(5px);
}
.selectCurrencies p {
  padding: 5px;
  background-color: var(--background-color);
  border-radius: 15px;
  cursor: pointer;
}
.selectedCurrency {
  color: #007aff;
}
.balanceBlock {
  color: var(--text-color1);
  display: flex;
  gap: 5px;
  justify-content: center;
  align-items: center;
  font-size: 32px;
  font-weight: 600;
  font-family: "SF Compact Rounded";
}

.balanceBlock p {
  font-family: "SF Compact Rounded";
}

.balanceBlock span {
  color: var(--text-color1);
  opacity: 0.3;
  font-family: "SF Compact Rounded";
}

.balanceBlock p span {
  color: var(--text-color2);
  opacity: 1;
}

.mainButtons {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 2%;
  justify-content: center;
  align-items: center;
}

.mainButton {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding-top: 7px;
  padding-bottom: 7px;
  color: #007aff;
  font-size: 13px;
  background-color: var(--button-background);
  border-radius: 15px;
  cursor: pointer;
}

.bannerBlock {
  border-radius: 14px;
  background-color: var(--button-background);
  padding: 10%;
  position: relative;
  transition: 0.3s all;
}

.closeBanner {
  position: absolute;
  top: 10px;
  right: 15px;
}

.activesBlock {
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow-y: auto;
  padding-right: 4px;
}

.activesBlock::-webkit-scrollbar {
  width: 4px;
}

.activesBlock::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}

.activeBlock {
  background-color: var(--second-color);
  border-radius: 14px;
  display: flex;
  align-items: center;
  padding: 10px;
  gap: 10px;
  cursor: pointer;
}

.activesText {
  text-align: left;
  color: var(--text-color1);
  font-size: 17px;
  letter-spacing: -0.43px;
  font-family: "SF Pro Text Bold";
}

.infoText {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.bottomActive {
  display: flex;
  flex-direction: column;
}
.headActive p {
  color: var(--text-color1);
  font-family: "SF Pro Text Bold";
  font-size: 17px;
}

.bottomActive p {
  color: var(--text-color2);
  font-size: 14px;
}
.bottomActive p:nth-child(1) {
  color: var(--text-color1);
  font-family: "SF Pro Text Bold";
  font-size: 17px;
}

.activeLine {
  display: flex;
  justify-content: space-between;
  text-align: left;
}

.active-icon {
  width: 32px;
  height: 32px;
  object-fit: contain;
}
.percentRed {
  color: #ff3535;
}
.percentGreen {
  color: #27c12d;
}
</style>
